import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPrinter$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPrinter extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b3b5d93db0909059c7da9b98f05f837f760d1ddd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ae29ba8f0d90c790a2776c5406e21493b5489eaf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '580707405f8e876c6f8a6077f41940a1b47b2c32', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17 5.793a.44.44 0 0 0-.15-.323l-2.99-2.827-.017-.016a.5.5 0 0 0-.329-.127H5.5a.49.49 0 0 0-.5.478V7.5H2.5A.5.5 0 0 0 2 8v8a.5.5 0 0 0 .5.5H5V19a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-2.5h2.5a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H17zM17 15h1.5V9h-15v6H5v-2a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5zM13.111 4 15.5 6.258V7.5h-9V4zM6.5 18v-4h9v4z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-printer", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-printer"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-printer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPrinter$1);
            }
            break;
    } });
}

const CosmosIconPrinter = CosmosIconPrinter$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPrinter, defineCustomElement };
